import Swal from "sweetalert2"

const fireSuccessToast = (message) => {
  Swal.fire({
    //toast: true,
    position: "center",
    icon: "success",
    //title: message,
    showConfirmButton: false,
    timer: 750,
    //timerProgressBar: true,
  })
}

const fireWarningToast = (message) => {
  Swal.fire({
    position: "center",
    icon: "warning",
    title: message,
    showConfirmButton: true,
    confirmButtonColor: "#3085d6",
  })
}

const fireErrorToast = (message) => {
  Swal.fire({
    position: "center",
    icon: "error",
    title: message,
    showConfirmButton: true,
    confirmButtonColor: "#3085d6",
  })
}

const fireConfirm = (title, message, callback) => {
  Swal.fire({
    icon: "question",
    title: title,
    text: message,
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Valider",
    cancelButtonColor: "#d33",
    cancelButtonText: "Annuler",
  }).then((response) => {
    if (response.isConfirmed) callback()
  })
}

const fireDeleteConfirm = (title, message, callback) => {
  Swal.fire({
    icon: "warning",
    title: title,
    text: message,
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Oui, supprimer !",
    cancelButtonColor: "#d33",
    cancelButtonText: "Annuler",
  }).then((response) => {
    if (response.isConfirmed) callback()
  })
}

const fireImportant = (title, message) => {
  Swal.fire({
    icon: "warning",
    title: title,
    text: message,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Compris !",
    allowOutsideClick: false,
  })
}

const fireInfo = (title, message) => {
  Swal.fire({
    icon: "info",
    title: title,
    text: message,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Fermer",
    allowOutsideClick: false,
  })
}

const askName = (title, message, placeholder, callback) => {
  Swal.fire({
    icon: "question",
    title: title,
    text: message,
    input: "text",
    inputAttributes: {
      required: true,
      placeholder: placeholder,
      autocomplete: "off",
    },
    validationMessage: `Le nom ne doit pas être vide`,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Valider",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    cancelButtonText: "Annuler",
    allowOutsideClick: false,
  }).then((response) => {
    if (response.isConfirmed) callback(response)
  })
}

const askNumber = (title, message, min, max, placeholder, callback) => {
  Swal.fire({
    icon: "question",
    title: title,
    text: message,
    input: "number",
    inputAttributes: {
      min: min,
      max: max,
      required: true,
      placeholder: placeholder,
      autocomplete: "off",
    },
    validationMessage: `La valeur doit être comprise entre ${min} et ${max}`,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Valider",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    cancelButtonText: "Annuler",
    allowOutsideClick: false,
  }).then((response) => {
    if (response.isConfirmed) callback(response)
  })
}

const askMediaType = async () => {
  const response = await Swal.fire({
    icon: "question",
    title: "Type de design",
    text: "Quel est le type du design Canva que vous souhaitez diffuser ?",
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Image",
    denyButtonColor: "#28a745",
    denyButtonText: "Vidéo",
    cancelButtonColor: "#d33",
    cancelButtonText: "Annuler",
    allowOutsideClick: false,
  })

  if (response.isConfirmed) {
    return "image"
  }
  if (response.isDenied) {
    return "video"
  }
  return null
}

const askDesignNameAndPlayer = (selectOptions, callback) => {
  Swal.fire({
    icon: "question",
    title: "Informations nécessaires",
    html: `
      <p>Veuillez renseigner le nom de votre nouveau design et de sélectionner un player pour que votre design ait les bonnes dimensions automatiquement.</p>
      <input id="swal-input1" autocomplete="off" class="swal2-input" placeholder="Mon design">
      <select id="swal-input2" class="swal2-input">
        ${selectOptions
        .map((option) => `<option value="${option.width}x${option.height}">${option.name}</option>`)
        .join("")}
        <option value="custom">Taille personnalisée</option>
      </select>
      <div id="custom-size-container" style="display:none; margin-top:8px;">
        <input id="custom-width" autocomplete="off" class="swal2-input" type="number" min="1" placeholder="Largeur (px)">
        <input id="custom-height" autocomplete="off" class="swal2-input" type="number" min="1" placeholder="Hauteur (px)">
      </div>
    `,
    focusConfirm: false,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Valider",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    cancelButtonText: "Annuler",
    didOpen: () => {
      const select = document.getElementById("swal-input2")
      const customContainer = document.getElementById("custom-size-container")
      select.addEventListener("change", () => {
        if (select.value === "custom") {
          customContainer.style.display = "block"
        } else {
          customContainer.style.display = "none"
        }
      })
    },
    preConfirm: () => {
      const name = document.getElementById("swal-input1").value
      const selectedOption = document.getElementById("swal-input2").value
      if (!name) {
        Swal.showValidationMessage("Le nom ne doit pas être vide")
        return false
      }
      if (selectedOption === "custom") {
        const width = document.getElementById("custom-width").value
        const height = document.getElementById("custom-height").value
        if (!width || !height || isNaN(width) || isNaN(height) || width <= 0 || height <= 0) {
          Swal.showValidationMessage("Veuillez entrer une largeur et une hauteur valides")
          return false
        }
        return { name, selectedOption: `${width}x${height}` }
      }
      return { name, selectedOption }
    },
    allowOutsideClick: false,
  }).then((response) => {
    if (response.isConfirmed) callback(response.value.name, response.value.selectedOption)
  })
}

const askNetworkSettings = (callback) => {
  Swal.fire({
    icon: "question",
    title: "Configuration réseau",
    html: `
      <p>Veuillez renseigner le nom du réseau ainsi que son mot de passe afin de permettre au player de s'y connecter automatiquement au démarrage.</p>
      <input id="swal-input1" name="network-ssid" autocomplete="off" class="swal2-input" type="text" placeholder="SSID">
      <input id="swal-input2" name="network-pwd" autocomplete="off" class="swal2-input" type="text" placeholder="Mot de passe">
    `,
    focusConfirm: false,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Valider",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    cancelButtonText: "Annuler",
    preConfirm: () => {
      const ssid = document.getElementById("swal-input1").value
      const password = document.getElementById("swal-input2").value
      if (!ssid || !password) {
        Swal.showValidationMessage("Le ssid et le mot de passe ne doivent pas être vides")
      }
      return { ssid, password }
    },
    allowOutsideClick: false,
  }).then((response) => {
    if (response.isConfirmed) callback(response.value.ssid, response.value.password)
  })
}

const askAiModuleSettings = (currentConfig, callback) => {
  Swal.fire({
    icon: "question",
    title: "Paramètres module Ciblage IA",
    html: `
      <p>Veuillez renseigner les informations de connexion au module de ciblage IA.</p>
      <input id="swal-input1" autocomplete="off" class="swal2-input" type="text"
        placeholder="192.168.1.100" value="${currentConfig?.ipAddress || ""}">
      <input id="swal-input2" autocomplete="off" class="swal2-input" type="text"
        placeholder="Nom d'utilisateur" value="${currentConfig?.username || ""}">
      <input id="swal-input3" autocomplete="off" class="swal2-input" type="password"
        placeholder="Mot de passe" value="${currentConfig?.password || ""}">
    `,
    focusConfirm: false,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Valider",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    cancelButtonText: "Annuler",
    didOpen: () => {
      const pwdInput = document.getElementById("swal-input3")
      const computedMargin = getComputedStyle(pwdInput).margin

      const wrapper = document.createElement("div")
      wrapper.style.cssText = "position:relative;display:inline-block;margin:" + computedMargin
      pwdInput.parentNode.insertBefore(wrapper, pwdInput)
      wrapper.appendChild(pwdInput)
      pwdInput.style.margin = "0"
      pwdInput.style.paddingRight = "36px"

      const toggleBtn = document.createElement("button")
      toggleBtn.type = "button"
      toggleBtn.innerHTML = '<i class="fas fa-eye"></i>'
      toggleBtn.style.cssText = "position:absolute;right:8px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;padding:4px;color:#6c757d;font-size:16px"
      wrapper.appendChild(toggleBtn)

      toggleBtn.addEventListener("click", () => {
        const isHidden = pwdInput.type === "password"
        pwdInput.type = isHidden ? "text" : "password"
        toggleBtn.innerHTML = isHidden
          ? '<i class="fas fa-eye-slash"></i>'
          : '<i class="fas fa-eye"></i>'
      })
    },
    preConfirm: () => {
      const ipAddress = document.getElementById("swal-input1").value.trim()
      const username = document.getElementById("swal-input2").value
      const password = document.getElementById("swal-input3").value

      if (!ipAddress || !username || !password) {
        Swal.showValidationMessage("Tous les champs sont requis")
        return false
      }

      const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/
      if (!ipv4Regex.test(ipAddress) || ipAddress.split(".").some((octet) => Number(octet) > 255)) {
        Swal.showValidationMessage("L'adresse IP n'est pas valide (ex: 192.168.1.100)")
        return false
      }

      return { ipAddress, username, password }
    },
    allowOutsideClick: false,
  }).then((response) => {
    if (response.isConfirmed) callback(response.value)
  })
}

const Sweetalert = {
  fireSuccessToast,
  fireWarningToast,
  fireErrorToast,
  fireConfirm,
  fireDeleteConfirm,
  fireImportant,
  fireInfo,
  askName,
  askNumber,
  askMediaType,
  askDesignNameAndPlayer,
  askNetworkSettings,
  askAiModuleSettings,
}

export default Sweetalert
